import { mapActions, mapGetters, mapMutations } from 'vuex'

export const highlightOffer = {
  props: {},

  data: () => ({}),

  computed: {
    ...mapGetters([
      'highlightTag',
      'isExpandedModel',
      'isDefaultModel',
      'highlightOffer',
      'highlightDisplayTitle',
      'highlightBannerImage',
      'highlightModelType',
      'highlightIconImage',
      'tagType',
      'highlightStatus',
      'isUsingHeaderImage',
      'highlightOfferSchedule',
    ]),
  },

  methods: {
    ...mapMutations(['SET_DISPLAY_TITLE', 'SET_HIGHLIGHT_KEY_VALUE', 'SET_TAG_TYPE', 'SET_STATUS']),
    ...mapActions([
      'setHighlightKeyValue',
      'upsertHighlight',
      'setHighlightObject',
      'validateHighlightStep1',
      'setTagType',
      'getHighlight',
      'setUseHeaderImage',
    ]),
  },
}
